import { useStore } from "@stores";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const useBlogPost = () => {
  const { slug } = useParams<{ slug: string }>();
  const { blogStore } = useStore();
  const { post } = blogStore;
  // Slug za koji je učitavanje završeno; dok se razlikuje od tekućeg, traje
  // učitavanje (pa promena slug-a odmah vraća loading bez setState u efektu).
  const [loadedSlug, setLoadedSlug] = useState<string>();
  const loading = !slug || slug !== loadedSlug;

  useEffect(() => {
    if (slug) {
      blogStore.getBySlug(slug).finally(() => setLoadedSlug(slug));
    }
    return () => blogStore.clear();
  }, [blogStore, slug]);

  return { post, loading };
};
